import BaseBlockContent from "@sanity/block-content-to-react";
import React from "react";
import clientConfig from "../../client-config";
import PortableText from "@sanity/block-content-to-react";
import { generateUrlPath } from './utils';

const serializerTOC= {
  types: {
    block: (props) => {
      const { node, children } = props
      const { style, _key } = node
        const headingTag = style;
const getClassName = ()=>{
    if(/^h2$/.test(style)){
        return 'h2Heading'
    }else if(/^h3$/.test(style)){
        return'h3Heading'
    }
}

      if (/^h[23]$/.test(headingTag)) {
        const processedURL = generateUrlPath(children[0])
        const headingId = `crema`+`-`+`${processedURL}`+`-`+`${_key}`;
        return (
          <li className={getClassName()}>
            <a
              href={`#${headingId}`}
              aria-hidden="true"
              tabIndex={-1}
            >{children}</a>
          </li>
          )
      }
    }
  }
};

const BlockTOC = ({ blocks }) => (
  <BaseBlockContent blocks={blocks} serializers={serializerTOC} {...clientConfig.sanity} />
);

export default BlockTOC;
